import { ApiV1_Category, ApiV1_Product } from '@pedix-workspace/api-v1';
import { getPropInSelectedLanguage, SUPPORTED_LANGUAGES } from '@pedix-workspace/utils';
import { createSearchIndex, SearchIndex } from './search-index';

export type SearchCatalogIndex = SearchIndex<ApiV1_Product>;

export type SearchResults = {
  category: ApiV1_Category;
  indexedProducts: {
    listIndex: number;
    product: ApiV1_Product;
  }[];
}[];

export type SearchCatalogIndexOptions = {
  selectedLanguage?: SUPPORTED_LANGUAGES;
  displaySku?: boolean;
};

export function createSearchCatalogIndex(
  categories: ApiV1_Category[],
  products: ApiV1_Product[],
  options: SearchCatalogIndexOptions,
): SearchCatalogIndex {
  const categoriesMap: Record<string, ApiV1_Category> = categories.reduce(
    (mapedCategories, category) =>
      Object.assign(mapedCategories, {
        [category.id]: category,
      }),
    {},
  );

  return createSearchIndex(products, {
    indexedKeywordsFn(entry) {
      const keywords = [
        getPropInSelectedLanguage(entry, 'name', options.selectedLanguage, true),
        getPropInSelectedLanguage(entry, 'groupName', options.selectedLanguage),
        getPropInSelectedLanguage(entry, 'description', options.selectedLanguage),
        getPropInSelectedLanguage(
          categoriesMap[entry.categoryId],
          'name',
          options.selectedLanguage,
          true,
        ),
        ...(entry.tags || []).map(productTag =>
          getPropInSelectedLanguage(productTag, 'tag', options.selectedLanguage, true),
        ),
      ];

      if (entry.presentations) {
        entry.presentations.items.forEach(item => {
          keywords.push(getPropInSelectedLanguage(item, 'name', options.selectedLanguage, true));
        });
      }

      if (options.displaySku && entry.sku) {
        keywords.push(entry.sku);
      }

      return keywords;
    },
  });
}
